import React from 'react';
import { useVisibilityHook } from 'react-observer-api';

function LazyLoad({ children }) {
  const { setElement, isVisible } = useVisibilityHook({
    threshold: 0.01
  });
  return <div ref={setElement}>{isVisible && children}</div>;
}

export default LazyLoad;
